import axios from "axios"
const controller = "/rendicion"

const RendicionService = {
    cargarArchivo: async (file, caj_id) => {
        let form = new FormData()
        form.append("file", file)
        form.append("id", caj_id)
        const { data } = await axios.post(`${controller}/cargarArchivo`, form)
        return data
    },
    adjuntarPdf: async (file, caj_id) => {
        let form = new FormData()
        form.append("file", file)
        form.append("id", caj_id)
        const { data } = await axios.post(`${controller}/adjuntarPdf`, form)
        return data
    },
    registrar: async (rendicion, lista_rendicion_detalle) => {
        const { data } = await axios.post(`${controller}/registrar`, {
            rendicion,
            lista_rendicion_detalle
        })
        return data
    },
    obtenerRendicionxCaja: async (caja) => {
        const { data } = await axios.post(`${controller}/obtenerRendicionxCaja`, {
            caja
        })
        return data
    },
    obtenerRendiciones: async (caja) => {
        const { data } = await axios.post(`${controller}/obtenerRendiciones`, {
            caja
        })
        return data
    },
    solicitarAprobacionRendicion: async (caja) => {
        const { data } = await axios.post(`${controller}/solicitarAprobacionRendicion`, {
            caja
        })
        return data
    },
    aprobar: async (caja) => {
        const { data } = await axios.post(`${controller}/aprobar`, {
            caja
        })
        return data
    },
    desaprobar: async (caja) => {
        const { data } = await axios.post(`${controller}/desaprobar`, {
            caja
        })
        return data
    },
    generarReporteRendicion: async (caja) => {
        const { data } = await axios.post(`${controller}/generarReporteRendicion`, {
            caja
        })
        return data
    },
}
export default RendicionService